module.exports = __webpack_public_path__ + "static/media/means_of_id.3561065d.svg";